import * as types from './mutation-types'

export default {
  [types.SET_CUSTOMIZATION] (state, obj) {
    state.customization = obj
  }
}
